import { render, staticRenderFns } from "./ClassifiedSingle.vue?vue&type=template&id=26f975da&"
import script from "./ClassifiedSingle.vue?vue&type=script&lang=js&"
export * from "./ClassifiedSingle.vue?vue&type=script&lang=js&"
import style0 from "./ClassifiedSingle.vue?vue&type=style&index=0&id=26f975da&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports